import { z } from 'zod';

import { BaseQuestionWidgetSchema } from './QuestionBaseSchema';
import { HelpersAndFeedbackDisplayLevel } from '../../../types/HelpersAndFeedbackDisplayLevel';
import { QuestionScoreDisplayLevel } from '../../../types/QuestionScoreDisplayLevel';
import { RelativeScoreMode } from '../../../types/questionScoreMode';
import { WidgetType } from '../../utils/widgetsUtils';

export enum GroupCheckButtonMode {
  GeneralButton = 'generalButton',
  OnEachQuestion = 'onEachQuestion'
}

export enum ParentHeadline {
  Manual = 'manual',
  Automatic = 'automatic',
  None = 'none'
}

export const QuestionGroupListWidgetStaticSchema = BaseQuestionWidgetSchema(WidgetType.QuestionGroupList).extend({
  // "commmon" question group list fields
  visibleQuestionsCount: z.number(),
  withRandomSubQuestions: z.boolean(),
  questionScoreDisplayLevel: z.nativeEnum(QuestionScoreDisplayLevel).optional(),
  requiredSubQuestionsId: z.array(z.string()),
  saveAnswers: z.boolean(),
  // "standard" question group list fields
  helpersAndFeedbackDisplayLevel: z.nativeEnum(HelpersAndFeedbackDisplayLevel).optional(),
  // "elective" question group list fields
  choiceQuestionsCount: z.number().optional(),
  choiceQuestionsEnabled: z.boolean().optional(),
  groupCheckButtonMode: z.nativeEnum(GroupCheckButtonMode).optional(),
  parentHeadline: z.nativeEnum(ParentHeadline).optional(),
  relativeScoreMode: z.nativeEnum(RelativeScoreMode).optional()
});

export type QuestionGroupListWidgetStaticSchemaType = z.infer<typeof QuestionGroupListWidgetStaticSchema>;
